// Typed client for guide version history (/v1/studio/guides/{id}/versions*).
// Versions are immutable snapshots minted at publish time; rollback forward-
// publishes an old snapshot as a new version.

import { apiRequest } from "./http";
import type { CharacterProfile } from "../types/guide";

export interface GuideVersionSummary {
  version: number;
  createdBy: string | null;
  note: string | null;
  createdAt: string | null;
}

export interface FrozenSkill {
  id: string;
  name: string;
  instructions: string;
}

export interface GuideVersion {
  guideId: string;
  version: number;
  config: CharacterProfile;
  compiledGuidePrompt: string | null;
  skills: FrozenSkill[];
  createdBy: string | null;
  note: string | null;
  createdAt: string | null;
}

export const listGuideVersions = (guideId: string) =>
  apiRequest<{ items: GuideVersionSummary[] }>(
    `/studio/guides/${encodeURIComponent(guideId)}/versions`,
  );

export const getGuideVersion = (guideId: string, version: number) =>
  apiRequest<GuideVersion>(
    `/studio/guides/${encodeURIComponent(guideId)}/versions/${version}`,
  );

// Restores AND republishes as a new version (the counter never rewinds).
export const rollbackGuideVersion = (guideId: string, version: number, note?: string) =>
  apiRequest<CharacterProfile>(
    `/studio/guides/${encodeURIComponent(guideId)}/versions/${version}/rollback`,
    { method: "POST", body: { note: note || null } },
  );
